import { gql } from "@apollo/client";

const SAVE_VISITA_CUMPLIMIENTO_INDICACION_AE = gql`
    mutation saveVisitaCumplimientoIndicacionAE($input: AddVisitaCumplimientoIndicacionInput!, $idTeleEnfermeria: Int!){
        saveVisitaCumplimientoIndicacionAE(input: $input, idTeleEnfermeria: $idTeleEnfermeria) {
            idCumplimientoIndicacion
        }
    }
`;

export default SAVE_VISITA_CUMPLIMIENTO_INDICACION_AE;

export const adaptAddVisitaCumplimientoIndicacionInput = (data) => ({
  idTeleEnfermeria: data?.idTeleEnfermeriaAE,
  input: {
    idCumplimientoIndicacion: data?.idCumplimientoIndicacion || 0,
    cambioIndicacionSemana: !!data?.cambioIndicacionSemana,
    dificultadCumplimiento: data?.dificultadCumplimiento,
    realizaEscalonamiento: !!data?.realizaEscalonamiento,
    indicacionActual: data?.indicacionActual,
    volumenDiario: data?.volumenDiario,
    bolsaUtilizada: data?.bolsaUtilizada,
    velocidadPasaje: data?.velocidadPasaje,
    horarioConexion: data?.horarioConexion,
    quienRealizaCI: data?.quienRealizaCI,
    procesoConexionDesconexion: data?.procesoConexionDesconexion,
    complementaViaOral: !!data?.complementaViaOral
  }
});